import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { AttachmentType } from 'src/app/shared/models/enums.model';

export class Attachment{

    Id:number;
    URL:string;
    BaseRequestId:string;
    DocumentName:string;
    BaseRequest: BaseRequest;
    AttachmentType:AttachmentType
    file?: File;
    AttachmentTypeId:number;
}
